import React, { useState, useEffect } from 'react';
import { useKeycloak } from './KeycloakProvider';
import './Login.css';

const Login = () => {
  const { initialized, authenticated, user, login, keycloak } = useKeycloak();
  const [error, setError] = useState(null);

  // Check for authentication errors
  useEffect(() => {
    if (initialized && !authenticated && keycloak) {
      // Check if there was an error in the URL
      const urlParams = new URLSearchParams(window.location.search);
      const errorParam = urlParams.get('error');
      const errorDescription = urlParams.get('error_description');
      
      if (errorParam) {
        if (errorParam === 'access_denied' || errorDescription?.includes('not authorized')) {
          setError('You are not authorized to access this application.');
        } else {
          setError('Authentication failed. Please try again.');
        }
      }
    }
  }, [initialized, authenticated, keycloak]);

  return (
    <div className="login-container">
      <div className="login-banner">
        <svg className="login-banner-text-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="16" x2="12" y2="12"/>
          <line x1="12" y1="8" x2="12.01" y2="8"/>
        </svg>
        <span className="login-banner-text">If you are an external client please visit</span>
        <a
          href="https://www.delhivery.com/maps"
          className="login-banner-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          delhivery.com/maps
        </a>
      </div>
      <div className="login-layout">
        <div className="login-left">
          <div className="login-left-content">
            <div className="delhivery-logo">
              <img
                className="delhivery-mark"
                src={require('../../assets/login/delhivery-mark.png')}
                alt="Delhivery"
              />
              <span className="delhivery-text">Delhivery</span>
            </div>
          </div>
          <div className="login-contact">
            CONTACT US: +91 (124) 6719500 | COPYRIGHT © DELHIVERY PVT. LTD.
          </div>
        </div>

        <div className="login-right">
          {!initialized ? (
            <div className="login-panel">
              <div className="login-loader"></div>
              <p className="login-loader-text">Initializing...</p>
            </div>
          ) : authenticated && user ? (
            <div className="login-panel">
              <div className="login-success">✓</div>
              <h1 className="login-title">Welcome</h1>
              <p className="login-subtitle">Loading your maps...</p>
            </div>
          ) : (
            <div className="login-panel">
              <h1 className="login-title">SIGN IN</h1>

              <button
                className="login-btn"
                onClick={() => {
                  setError(null);
                  login({
                    idpHint: 'google'
                  });
                }}
              >
                <span className="login-btn-icon">G+</span>
                SIGN IN USING DELHIVERY ID
              </button>

              {error && (
                <div className="login-error">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="8" x2="12" y2="12"/>
                    <line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>
                  {error}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
